import script from "./ChiTietNhapTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChiTietNhapTable.vue?vue&type=script&setup=true&lang=ts"

import "./ChiTietNhapTable.vue?vue&type=style&index=0&id=cb6b8aba&lang=scss&scoped=true"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb6b8aba"]])

export default __exports__